export const COUNTS_EVENT = "portal:counts";
/** Fired by screens after a change that affects the sidebar counts. */
export const refreshCounts = () => window.dispatchEvent(new Event(COUNTS_EVENT));
